import * as IntlCustom from './intl';

export { IntlCustom };
